import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import request from '@/api/request';

export const useAuthStore = defineStore('auth', () => {
  const token = ref(localStorage.getItem('crm_token') || '');
  const user = ref(null);
  const loading = ref(false);

  const isLoggedIn = computed(() => !!token.value);
  const isSuperAdmin = computed(() => user.value?.role === 'super-admin');
  const isAdmin = computed(() => user.value?.role === 'admin' || user.value?.role === 'super-admin');

  function setToken(newToken) {
    token.value = newToken;
    localStorage.setItem('crm_token', newToken);
  }

  function clearAuth() {
    token.value = '';
    user.value = null;
    localStorage.removeItem('crm_token');
  }

  async function loginByPassword(username, password) {
    loading.value = true;
    try {
      const res = await request.post('/auth/login', { username, password });
      setToken(res.data.token);
      user.value = res.data.user;
      return res.data;
    } finally {
      loading.value = false;
    }
  }

  async function loginByWecomCode(code) {
    loading.value = true;
    try {
      const res = await request.post('/auth/wecom/callback', { code });
      setToken(res.data.token);
      user.value = res.data.user;
      return res.data;
    } finally {
      loading.value = false;
    }
  }

  async function fetchUser() {
    try {
      const res = await request.get('/auth/me');
      user.value = res.data;
      return res.data;
    } catch {
      clearAuth();
      return null;
    }
  }

  async function getWecomAuthUrl(redirectUri) {
    const res = await request.get('/auth/wecom/url', { params: { redirectUri } });
    return res.data;
  }

  async function changePassword(oldPassword, newPassword) {
    const res = await request.put('/auth/change-password', { oldPassword, newPassword });
    return res.data;
  }

  function logout() {
    clearAuth();
    window.location.href = '/login';
  }

  return {
    token,
    user,
    loading,
    isLoggedIn,
    isSuperAdmin,
    isAdmin,
    setToken,
    clearAuth,
    loginByPassword,
    loginByWecomCode,
    fetchUser,
    getWecomAuthUrl,
    changePassword,
    logout,
  };
});
